import { useEffect } from 'react';

const DEFAULT_VIEWPORT =
  'width=device-width, initial-scale=1.0, viewport-fit=cover';
const NO_ZOOM_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

/**
 * En Chats (lista / hilo) bloquea pinch y double-tap zoom del navegador,
 * típico de apps tipo WhatsApp. Se restaura al salir de la sección.
 */
export function useDisableChatPageZoom(): void {
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    const prev = meta?.getAttribute('content') || DEFAULT_VIEWPORT;
    meta?.setAttribute('content', NO_ZOOM_VIEWPORT);

    const blockGesture = (e: Event) => {
      e.preventDefault();
    };
    // iOS Safari legacy: gesture* dispara en pinch zoom
    document.addEventListener('gesturestart', blockGesture, { passive: false });
    document.addEventListener('gesturechange', blockGesture, { passive: false });
    document.addEventListener('gestureend', blockGesture, { passive: false });

    return () => {
      meta?.setAttribute('content', prev);
      document.removeEventListener('gesturestart', blockGesture);
      document.removeEventListener('gesturechange', blockGesture);
      document.removeEventListener('gestureend', blockGesture);
    };
  }, []);
}
